(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', () => this.step(button.name === 'plus' ? 1 : -1))
          );
        }

        step(direction) {
          const min = Number(this.input.min) || 0;
          const next = Math.max(min, (Number(this.input.value) || min) + direction);
          if (next === Number(this.input.value)) return;
          this.input.value = next;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
